import React from 'react'

import Layout from '../components/Layout'
import SEO from '../components/SEO'
import HeroHeader from '../components/HeroHeader'
import BodySection from '../components/BodySection'
import FooterSection from '../components/FooterSection'
import Footer from '../components/Footer'

const IndexPage = () => (
  <Layout>
    <SEO title="Neo Delivery - Livrări urbane și ieftine și rapide." />
    <HeroHeader/>
    <BodySection/>
    <FooterSection/>
    <Footer/>
  </Layout>
)

export default IndexPage
